import gql from 'graphql-tag';

export const AIRCRAFT_FIELDS = gql`
    fragment AircraftFields on HistoryAircraft {
        _id
        model
        tailNum
        maxSeats
        maxLoad
    }
`;

export const FINALIZED_FLIGHTS = gql`
    ${AIRCRAFT_FIELDS}
    query FinalizedFlights(
        $tpID: ID!
        $customerID: ID
        $startDate: AWSDate!
        $endDate: AWSDate!
        $departureID: ID
        $bookmark: String
    ){
        getFinalizedFlights(
            tpID: $tpID
            customerID: $customerID
            startDate: $startDate
            endDate: $endDate
            departureID: $departureID
            limit: 100
            bookmark: $bookmark
        ){
            execution_stats {
                execution_time_ms
                results_returned
                total_keys_examined
                total_docs_examined
                total_quorum_docs_examined
            }
            bookmark
            docs {
                _id
                modifiedTs
                modifiedBy
                ... on HistoryFlightNode {
                    _id
                    desig
                    legs
                    firstLegUsableWt
                    scheduledFlightDate
                    lastKnownController {
                        _id
                        name
                    }
                    legsArray {
                        paxCount
                        paxWeight
                        flightTime
                    }
                    paxIDList {
                        _id
                        chargeCode
                        transitType
                    }
                    cgoIDList {
                        _id
                        chargeCode
                        transitType
                    }
                    aircraftID {
                        ...AircraftFields
                    }
                }
            }
        }
    }
`;

export const FINALIZED_FLIGHTS_FULL = gql`
    ${AIRCRAFT_FIELDS}
    query FinalizedFlightsFull(
        $tpID: ID!
        $customerID: ID
        $startDate: AWSDate!
        $endDate: AWSDate!
        $departureID: ID
    ){
        getFinalizedFlights(
            tpID: $tpID
            customerID: $customerID
            startDate: $startDate
            endDate: $endDate
            departureID: $departureID
        ){
            execution_stats {
                execution_time_ms
                results_returned
                total_keys_examined
                total_docs_examined
                total_quorum_docs_examined
            }
            docs {
                _id
                modifiedTs
                modifiedBy
                ... on HistoryFlightNode {
                    _id
                    originalFlightID
                    desig
                    legs
                    timeOfDeparture
                    scheduledFlightDate
                    scheduleType
                    firstLegUsableWt
                    lastKnownController {
                        _id
                        name
                    }
                    legsArray {
                        flightTime
                        order
                        departure
                        departureID
                        destination
                        destinationID
                        paxCount
                        paxWeight
                        cgoCount
                        paxIDs {
                            _id
                            firstName
                            lastName
                            paxWeight
                            chargeCode
                            individualLegTime
                            departureDoc {
                                _id
                                name
                            }
                            destinationDoc {
                                _id
                                name
                            }
                            transitType
                        }
                        cgoIDs {
                            _id
                            name
                            approvedBy
                            departureDoc {
                                _id
                                name
                            }
                            destinationDoc {
                                _id
                                name
                            }
                            weight
                            transitType
                            deliveredBy
                        }
                    }
                    pilot {
                        _id
                        name {
                            firstName
                            lastName
                        }
                    }
                    copilot {
                        _id
                        name {
                            firstName
                            lastName
                        }
                    }
                    contract {
                        _id
                        name
                    }
                    paxIDList {
                        _id
                        firstName
                        lastName
                        chargeCode
                        individualLegTime
                        departureDoc {
                            _id
                            name
                        }
                        employerDoc {
                            _id
                            name
                        }
                        destinationDoc {
                            _id
                            name
                        }
                        transitType
                    }
                    cgoIDList {
                        _id
                        name
                        chargeCode
                        approvedBy
                        individualLegTime
                        departureDoc {
                            _id
                            name
                        }
                        destinationDoc {
                            _id
                            name
                        }
                        weight
                        transitType
                        deliveredBy
                    }
                    aircraftID {
                        ...AircraftFields
                    }
                }
            }
        }
    }
`;

